import React from 'react';
import { DatePicker, Form } from 'antd';

const FormItem = Form.Item;

const AntdDatePickerWithFormik = ({
  label,
  field,
  form,
  submitCount,
  ...props
}) => {
  const { touched, errors } = form;
  const { inputReadOnly } = props;
  const submitted = submitCount > 0;
  return (
    <div className='field-container'>
      <FormItem
        label={label}
        hasFeedback={submitted}
        help={
          touched[field.name] && errors[field.name] ? errors[field.name] : false
        }
        validateStatus={
          touched[field.name] && errors[field.name] ? 'error' : 'success'
        }
      >
        <DatePicker
          {...props}
          dropdownClassName={`birthday-date-picker ${
            inputReadOnly ? 'birthday-date-picker-input-hidden' : ''
          }`}
          onChange={value => form.setFieldValue(field.name, value)}
        />
      </FormItem>
    </div>
  );
};

export default AntdDatePickerWithFormik;
